import { onUnmounted } from "vue";
import { registerWindowTitle } from "@/router/branding";

/**
 * The browser tab's title while the calling component is mounted: what `parts` returns, joined by
 * " - " (`Project - Types`, `Dataspace - Process`). `null`, or any empty part, leaves the title to
 * whatever is beneath — the section's own, or the layout's when a view inside it calls this too.
 */
export function useWindowTitle(parts: () => (string | null | undefined)[] | null): void {
	onUnmounted(
		registerWindowTitle(() => {
			const list = parts();
			if (!list || list.some((part) => !part)) return null;
			return list.join(" - ");
		}),
	);
}
